import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { Case } from "../../../../models/case";
import { ServiceRequest } from 'src/app/models/service.request';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';
import { RequestSummary } from "../../../../models/request-summary";
import { ServiceDefService } from "../../../../services/servicedef.service";
import { TransactionHistoryService } from "../../../../services/transactionhistory.service";
import { ServiceRequestType } from 'src/app/models/service-request-type';
import { ServiceDef } from 'src/app/models/service-def';
import { RequestStatus } from 'src/app/models/request-status';
import { NewMessageHelper } from "../../drawer/mailmessages/newmessage/newmessage-helper";
import { MessageService } from "primeng/api";
import { MessageDefinitionService } from "../../../../services/messages.service";

@Component({
	selector: 'app-add-new-request-compact',
	templateUrl: './add-new-request-compact.component.html',
	styleUrls: ['./add-new-request-compact.component.css']
})
export class AddNewRequestCompactComponent implements OnInit {

	public strErr: string | null = '';
	public isEditing = false;

	public _caseId = 0;
	public newRequestRecord: ServiceRequest;

	public requestSummary: RequestSummary;

	/***** Control Strip Button Visibility ***/
	public visibleAdd: boolean | null = false;
	public visibleMatch: boolean | null = false;
	public visibleApprove: boolean | null = false;
	public visibleStatus: boolean | null = false;
	public visibleCollaborate: boolean | null = false;

	public submitEnabled: boolean = false;
	public cancelEnabled: boolean = true;
	public selectedServiceRequestTypeId: number;
	public selectedRequestType: ServiceRequestType;

	public selectedServiceDefId: number;
	public selectedDef: ServiceDef;

	public valCaseNumber = '';
	public valCaseName = '';
	public valRequestId = 0;
	public valAmountRequested = 0;
	public startDate = '';
	public endDate = '';
	public serviceRequestTypes;
	public serviceDefs: any;
	public serviceDefsAll: any;
	public uomList;
	public requestStatuses: RequestStatus[];
	public unitOfMeasure: string | null = '';
	public caseName: string;
	public caseNumber: string;
	public autoEmailRequest: boolean;
	public Idx: number = -1;
	public msgHelper: NewMessageHelper;
	public caseInfo: Case;
	public valCurrentNeed: string;

	@Output() editEvent = new EventEmitter<any>();

	@Output() submitClickedEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() cancelClickedEvent: EventEmitter<any> = new EventEmitter();


	constructor(private serviceRequestsService: ServiceRequestsService,
		public txService: TransactionHistoryService,
		public messageService: MessageDefinitionService,
		public serviceDefService: ServiceDefService) {
		this.requestSummary = new RequestSummary();
	}

	public ngOnInit() {
		if (Settings.getInstance().regionsList === undefined) {
			this.loadRegionsList();
		}
		this.visibleAdd = true;
		this.visibleMatch = true;
		this.visibleApprove = true;
		this.visibleStatus = true;
		this.visibleCollaborate = true;

	}
	public loadRegionsList() {
		this.serviceDefService.getAllRegions().subscribe(
			(result) => {
				Settings.getInstance().regionsList = result;
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve region data from the service');
			}
		)
	}
	public onShowHandler(caseId: number, caseNumber: string, caseName: string, currentNeed: string) {

		this.initRecord();
		this.serviceRequestTypes = Settings.getInstance().serviceRequestTypesList.filter(
			item => item.activeStatus === 'Active'
		);
		/** only show active Service Defs **/
		this.serviceDefsAll = Settings.getInstance().serviceDefsList.filter(s => s.activeStatus === 'Active');
		this.requestStatuses = Settings.getInstance().requestStatuses;
		this.uomList = Settings.getInstance().uomList;
		this._caseId = caseId;
		this.caseNumber = caseNumber;
		this.caseName = caseName;
		this.submitEnabled = true;
		this.valCurrentNeed = currentNeed;

		this.displayDetails();

	}
	public initRecord(): void {
		this.selectedServiceRequestTypeId = 0;
		this.unitOfMeasure = null;
		this.valAmountRequested = 0;
		this.startDate = '';
		this.endDate = '';
		this.selectedServiceDefId = 0;
	}
	public setRecord(): void {

		this.newRequestRecord = new ServiceRequest();
		this.newRequestRecord.caseNumber = this.valCaseNumber;
		this.newRequestRecord.caseId = this._caseId;
		this.newRequestRecord.totalAmountProvided = 0;
		this.newRequestRecord.amountRequested = this.valAmountRequested;
		this.newRequestRecord.serviceRequestTypeId = this.selectedServiceRequestTypeId;
		this.newRequestRecord.unitOfMeasure = this.fetchUnitOfMeasure(this.unitOfMeasure);
		this.newRequestRecord.requestStatusId = 2;
		this.newRequestRecord.startDate = this.startDate + 'T06:00';
		this.newRequestRecord.endDate = this.endDate + 'T06:00';
		this.newRequestRecord.agencyId = Settings.getInstance().loggedInUser.agencyId;
		this.newRequestRecord.currentNeed = this.valCurrentNeed;

		/** if there was no service definition selected - then we will treat it
			like an unmatched service request - so zero out the agencyId - set the status to 1
			**/
		if ((this.selectedServiceDefId === undefined) || (this.selectedServiceDefId <= 0)) {
			this.newRequestRecord.serviceDefId = this.selectedServiceDefId;
			this.newRequestRecord.agencyId = 0;
			this.newRequestRecord.requestStatusId = 1;
			this.autoEmailRequest = false;
		}
		else {
			this.newRequestRecord.serviceDefId = this.selectedServiceDefId;
			this.newRequestRecord.assignAttempts = 1;
			this.autoEmailRequest = true;
		}
		this.newRequestRecord.dueDate = DwUtils.getDueDate(new Date(), this.getServiceRequestType(this.selectedServiceRequestTypeId).baseDurationDays);
	}
	public fetchUnitOfMeasure(desc: string): string {
		let uomDesc = '';
		if (desc === null) {
			return '';
		}
		try {
			uomDesc = this.uomList.find(s => s.description === desc).description;
		}
		catch {
			// nothing.
		}

		return uomDesc;
	}
	public submitRecord() {

		this.submitEnabled = false;
		this.strErr = '';

		if (!this.validateFields()) {
			this.submitEnabled = true;
			return;
		}
		this.setRecord();
		this.serviceRequestsService.createServiceRequest(this.newRequestRecord).subscribe(
			(data) => {
				if (!data?.success || !data?.result?.id) {
					this.strErr = data?.message || 'Error: The server could not create new request';
					this.submitEnabled = true;
					return;
				}
				this.newRequestRecord.id = data.result.id;
				this.isEditing = false;

				this.editEvent.emit(this.isEditing);
				this.submitClickedEvent.emit();
			},
			(error) => {
				this.strErr = 'Error: The server could not create new request';
				this.submitEnabled = true;
			});
	}
	public validateFields(): boolean {

		this.strErr = '';
		if (!this.selectedRequestType) {
			this.strErr = 'Please select request type';
			//DwUtils.setFocus(vr.focus_field);
			return false;
		}
		if (DwUtils.chkValidDate(this.startDate) === false) {
			this.strErr = 'Error: Badly formed date - should be YYYY-MM-DD';
			DwUtils.highlightFocus('startDateId');
			console.log('Invalid Start Date: <' + this.startDate + '>');
			return false;
		}

		if (DwUtils.chkValidDate(this.endDate) === false) {
			this.strErr = 'Error: Badly formed date - should be YYYY-MM-DD';
			DwUtils.highlightFocus('endDateId');
			console.log('Invalid End Date: <' + this.endDate + '>');
			return false;
		}

		if (DwUtils.chkDateRange(this.startDate, this.endDate) === false) {
			this.strErr = 'Error: Invalid range: start date is greater than end date';
			DwUtils.highlightFocus('startDateId');
			return false;
		}

		if (!this.valAmountRequested) {
			this.strErr = 'Please enter amount/quantity';
			return false;
		}
		if (!this.unitOfMeasure) {
			this.strErr = 'Please select unit of measure';
			return false;
		}
		return true;
	}
	public cancelSubmitRecord() {
		this.strErr = '';
		this.editEvent.emit(this.isEditing);
		this.cancelClickedEvent.emit();
	}
	public displayDetails() {
		this.valRequestId = 0;
		this.valCaseName = this.caseName;
		this.valCaseNumber = this.caseNumber;
		this.isEditing = true;
		this.selectedRequestType = null;
	}
	public setServiceType(): void {

		if (this.selectedServiceRequestTypeId > 0) {
			this.selectedRequestType = this.serviceRequestTypes.find(s => s.id === this.selectedServiceRequestTypeId);

			/** check to see if we have a service type that matches the request type - and put it in the drop-down. ***/
			this.serviceDefs =
				this.serviceDefsAll.filter(s => s.serviceRequestTypeId === this.selectedServiceRequestTypeId && s.agencyId === Settings.getInstance().loggedInUser.agencyId);
		}
	}
	public setServiceDef(): void {

		if (this.selectedServiceDefId > 0) {
			this.selectedDef = this.serviceDefs.find(s => s.id === this.selectedServiceDefId);
		}
	}
	public getServiceRequestType(paramId): ServiceRequestType {
		for (const rec of Settings.getInstance().serviceRequestTypesList) {
			if (rec.id === paramId) {
				return rec;
			}
		}
		return new ServiceRequestType();
	}
}
